var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 0.75H0.8125C0.709375 0.75 0.625 0.834375 0.625 0.9375V2.4375C0.625 2.54063 0.709375 2.625 0.8125 2.625H19.1875C19.2906 2.625 19.375 2.54063 19.375 2.4375V0.9375C19.375 0.834375 19.2906 0.75 19.1875 0.75ZM19.1875 15.375H0.8125C0.709375 15.375 0.625 15.4594 0.625 15.5625V17.0625C0.625 17.1656 0.709375 17.25 0.8125 17.25H19.1875C19.2906 17.25 19.375 17.1656 19.375 17.0625V15.5625C19.375 15.4594 19.2906 15.375 19.1875 15.375ZM19.1875 8.0625H0.8125C0.709375 8.0625 0.625 8.14688 0.625 8.25V9.75C0.625 9.85313 0.709375 9.9375 0.8125 9.9375H19.1875C19.2906 9.9375 19.375 9.85313 19.375 9.75V8.25C19.375 8.14688 19.2906 8.0625 19.1875 8.0625Z",
    fill: "#F9D9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.547fd79e92f7f498ec8d715e06ef2a41.svg";
export { ForwardRef as ReactComponent };